import { CreditUsageWarnings, type CreditBlotterExposure } from '@talos/kyoko';

export function renderCreditWarningDetails(data: CreditBlotterExposure) {
  const warning = data.creditUsageWarning;
  return warning == null ? null : (
    <CreditUsageWarnings warning={warning} isWarningAggregatedFromChild={false} variant="mobileDetail" />
  );
}
